/**
 * The regexes of the application.
 */
class Regexes {

    /**
     * Finds any title cased characters of a string.
     */
    static CamelCaseFinder: RegExp = new RegExp(`[A-Z]`, 'g');

    /**
     * Finds any title cased characters of a string.
     */
    static Email: RegExp = new RegExp(/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})*$/, 'g');

    /**
     * Finds any characters that are not letters, numbers, or spaces.
     */
    static noSpecialCharacters: RegExp = new RegExp(`[^\\p{L}\\p{N} ]`, 'gu');

    /**
     * Finds any characters that are not letters, numbers, or spaces.
     */
    static specialCharacters: RegExp = new RegExp(`[^\\p{L}\\p{N} ]`, 'gu');

}

export default Regexes;
